import { Injectable } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { TitleStrategy, RouterStateSnapshot } from '@angular/router';
import { SessionService } from '@services/session/session.service';
import { DEFAULT_TENANT, STORE_NAME } from '@models/layout-state.model';

@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  private title_case: TitleCasePipe = new TitleCasePipe();

  constructor(private title_svc: Title, private session_svc: SessionService) {
    super();
  }

  override updateTitle(router_state: RouterStateSnapshot): void {
    const title: string | undefined = this.buildTitle(router_state);
    const tenant: string | undefined = this.session_svc.getTenantInfo()?.name;

    this.title_svc.setTitle(
      this.title_case.transform(`${tenant ?? DEFAULT_TENANT} ${STORE_NAME}`) +
        (title ? ` - ${title}` : '')
    );
  }
}
